import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'
import {
  ISobAnalyticsReportChartDataQuarter,
  ISobAnalyticsReportWeightedAverageNetNdp,
} from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportWeightedAverage'

import { calculateWeightedAverageNetNdp } from './calculateWeightedAverageNetNdp'

interface IGetChartData {
  data: ISobAnalyticsReportJoined[]

  currentYear: number
  shouldShowFutureYears?: boolean
  getAllowedQuarters: () => string[]
}

export const getChartData = ({
  data,
  currentYear,
  shouldShowFutureYears,
  getAllowedQuarters,
}: IGetChartData): {
  quartersChartData: ISobAnalyticsReportChartDataQuarter[]
  yearChartsData: ISobAnalyticsReportWeightedAverageNetNdp[]
} => {
  const prevYear = currentYear - 1

  const years = shouldShowFutureYears
    ? [prevYear, currentYear, currentYear + 1, currentYear + 2]
    : [prevYear, currentYear]

  const { quarterResults, yearlyResults } = calculateWeightedAverageNetNdp({
    reports: data,
    years,
  })

  const filteredQuarterResults = quarterResults.filter((it) => it.year <= currentYear)

  const allowedQuarters = getAllowedQuarters()

  const showedQuarterResults = filteredQuarterResults.map((item) => {
    if (item.year === prevYear || allowedQuarters.includes(item.quarter)) {
      return item
    }

    return {
      ...item,
      actuals: undefined,
      actualsNet: undefined,
    }
  })

  return { quartersChartData: showedQuarterResults, yearChartsData: yearlyResults }
}
